import * as React from 'react';
import { MyNotifications } from './my-notifications/my-notifications';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { STATE } from 'app/constants';
import { TabContainer } from 'app/components';
import { UserSettings } from 'app/area/user-profile/settings/settings';
import { userProfileTranslations } from 'app/area/user-profile/constants';
import { NoContent } from 'app/area/user-profile/no-content';
import { UserProfileSectionType } from 'app/routes/route-constants';
import { Configuration } from 'app/area/user-profile/types';
import { userProfileTabsFactory } from './user-profile-tabs';
import { UserDefaultValues } from 'app/area/user-profile/default-values/default-values';
import { configuration } from 'app/area/user-profile/configuration';
import { Subscriptions } from 'app/area/user-profile/subscriptions/subscriptions';

type UserProfileComponentProps = DefaultContainerProps & { activeSection: UserProfileSectionType };

export class UserProfileComponent extends React.Component<UserProfileComponentProps> {
  public static statePath: string = STATE.userProfile;

  private renderTabContainer = (conf: Configuration[]) => {
    const { activeSection, translation } = this.props;

    const renderUserProfileTabs = userProfileTabsFactory(conf, activeSection, translation);

    return <TabContainer
      label={translation.menu_text}
      visible={conf.filter(f => !!f.visible).length > 1}
      expandAll={false}
      activeSection={activeSection}
      translation={this.props.translation}
      renderTabs={renderUserProfileTabs} />;
  }

  private shouldRender(activeSection: string, conf: Configuration[]) {
    const activeSectionData = conf.find(c => c.section === activeSection);
    return activeSectionData && activeSectionData.visible;
  }

  private renderActiveSection(conf: Configuration[]) {
    const { activeSection } = this.props;

    const sections = {
      [UserProfileSectionType.Settings]: UserSettings,
      [UserProfileSectionType.Notifications]: MyNotifications,
      [UserProfileSectionType.DefaultValues]: UserDefaultValues,
      [UserProfileSectionType.Subscriptions]: Subscriptions
    };

    const Component = this.shouldRender(activeSection, conf) ? sections[activeSection] : NoContent;
    return <Component {...this.props} />;
  }

  public render() {
    const { sharedState: { showNotificationChannelsInfo, showSubscriptions } } = this.props;
    const conf = configuration({ showNotificationChannelsInfo, showSubscriptions });

    return <>
      {this.renderTabContainer(conf)}
      {this.renderActiveSection(conf)}
    </>;
  }
}

const selectors = {
  activeSection: (_: any, props: DefaultContainerProps) => props.params && props.params.focus || UserProfileSectionType.Settings
};

const container = containerFactory(UserProfileComponent, {}, selectors, userProfileTranslations);

export { container as UserProfileView };
